import React from 'react';
import Loadable from 'react-loadable';

// eslint-disable-next-line import/no-default-export
export default Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "SaveListingModalContainer" */
      './SaveListingModalContainer'
    ),
  loading: () => <div />,
});
